import { render } from "./SelfRegistration.vue?vue&type=template&id=74b98a4c&scoped=true"
import script from "./SelfRegistration.vue?vue&type=script&lang=js"
export * from "./SelfRegistration.vue?vue&type=script&lang=js"

import "./SelfRegistration.vue?vue&type=style&index=0&id=74b98a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b98a4c"]])

export default __exports__